let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("8JZKd"), load("h71ah")]).then(() => parcelRequire('4x46F'));